import { typeset } from '@helpers/mathjax';
import Vue from 'vue';

Vue.directive('mathjax', {
    bind: function (el, binding, vnode) {
        typeset(() => {
            el.innerHTML = binding.value;
            return [el];
        });
    }
});
